import { useHistory, useLocation } from 'quartz-routing/react-router';
import { useCallback, useMemo } from 'react';
import { trackPlanBuilderInteraction } from '../../utils/tracking';
import { buildFscTierSwitchSearch, parseFscUrlCart } from './fscUrlCart';
import { useFscCreditPacks } from './useFscCreditPacks';
import { useFscOrderSummary } from './useFscOrderSummary';
import { useFscPriceCatalog } from './useFscPriceCatalog';
import { useFscSeatsCard } from './useFscSeatsCard';
import { usePublicFscCompareSeats } from './usePublicFscCompareSeats';
import { useFscTermToggle } from './useFscTermToggle';
export function useReadyFscConfigurePage({
  catalog,
  selectedTier,
  selectedTierOption,
  term,
  tierOptions,
  browserLocale,
  preferredCountryCode,
  currencyCode
}) {
  const history = useHistory();
  const {
    search
  } = useLocation();
  const cart = useMemo(() => parseFscUrlCart(search, catalog, selectedTier), [catalog, search, selectedTier]);
  const onSelectTier = useCallback(tier => {
    var _tierOptions$find;
    const apiName = (_tierOptions$find = tierOptions.find(option => option.tier === tier)) === null || _tierOptions$find === void 0 ? void 0 : _tierOptions$find.apiName;
    if (!apiName) return;
    trackPlanBuilderInteraction({
      component: 'fsc-tier-selector',
      action: 'select-tier',
      apiName,
      value: tier,
      productNames: [apiName],
      activeCurrencyCode: currencyCode
    });
    history.replace({
      search: buildFscTierSwitchSearch(search, catalog, tier)
    });
  }, [tierOptions, catalog, currencyCode, history, search]);
  const priceCatalog = useFscPriceCatalog({
    catalog,
    selectedTier,
    browserLocale,
    preferredCountryCode,
    currencyCode,
    term
  });
  const termToggle = useFscTermToggle({
    purchaseOptions: selectedTierOption.pricing.purchaseOptions,
    term,
    productApiName: selectedTierOption.productApiName
  });
  const seatsCard = useFscSeatsCard({
    catalog,
    selectedTier,
    cart,
    currencyCode,
    pricesByApiName: priceCatalog.pricesByApiName,
    isPriceLoading: priceCatalog.isPriceLoading || priceCatalog.error !== undefined,
    onSelectTier
  });
  const compareSeats = usePublicFscCompareSeats({
    tierOption: selectedTierOption,
    products: catalog.products,
    pricesByApiName: priceCatalog.pricesByApiName,
    currencyCode
  });
  const creditPacks = useFscCreditPacks({
    catalog,
    selectedTier,
    cart,
    currencyCode,
    term,
    productPlanOptions: priceCatalog.productPlanOptions,
    isPriceLoading: priceCatalog.isPriceLoading
  });
  const orderSummary = useFscOrderSummary({
    catalog,
    selectedTier,
    cart,
    term,
    browserLocale,
    preferredCountryCode,
    currencyCode
  });
  return {
    tierSelector: {
      options: tierOptions,
      selectedTier,
      currencyCode,
      onSelectTier
    },
    seatsCard,
    compareSeats,
    creditPacks,
    termToggle,
    orderSummary
  };
}